export const ossURL = 'http://storage.joyreserve.com/Public/phoenix'
// export const baseURL = 'https://johnson.joyreserve.com/index.php/'
export const baseURL = process.env.REACT_APP_API
